


document.addEventListener("DOMContentLoaded", function () {

 
  // Colour swatch product JS 
    const currentPath = window.location.pathname;

    document.querySelectorAll(".text-inherit").forEach(swatch => {
        swatch.classList.remove("active");

        const swatchPath = new URL(
            swatch.href,
            window.location.origin
        ).pathname;

        if (swatchPath === currentPath) {
            swatch.classList.add("active");
        }
    });

    // color swatch hover display color name
    
    document.querySelectorAll('.text-inherit').forEach(link => {

    link.addEventListener('mouseenter', function () {

      // Remove existing tooltip
      document.querySelectorAll('.variant-name-tooltip').forEach(el => el.remove());

      const href = this.getAttribute('href');
      if (!href) return;

      const handle = href.split('/products/')[1] || '';
      console.log(handle);
      
      const tooltip = document.createElement('div');
      tooltip.className = 'variant-name-tooltip';
      tooltip.textContent = handle
        .replace(/-/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase());

      this.style.position = 'relative';
      this.appendChild(tooltip);
    });

    link.addEventListener('mouseleave', function () {
      const tooltip = this.querySelector('.variant-name-tooltip');
      if (tooltip) tooltip.remove();
    });

  });


  // Applicator JS


  let zoomInitialized = false;

function initApplicatorZoom() {
  if (window.innerWidth <= 749 && !zoomInitialized) {
    zoomInitialized = true;

    const sections = document.querySelectorAll('.applicator-image-wrapper');

    const handleZoom = () => {
      sections.forEach(section => {
        const img = section.querySelector('img');
        const rect = section.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        if (rect.top < windowHeight && rect.bottom > 0) {
          const progress =
            (windowHeight - rect.top) /
            (windowHeight + rect.height);

          const scale =
            1 + Math.min(Math.max(progress, 0), 1) * 0.15;

          img.style.transform = `scale(${scale})`;
        }
      });
    };

    window.addEventListener('scroll', handleZoom);
    handleZoom();
  }
}

initApplicatorZoom();
window.addEventListener('resize', initApplicatorZoom);

  // Accordion JS

  document.querySelectorAll('.shopify-section').forEach((section) => {
  const accordions = section.querySelectorAll('details');

  accordions.forEach((accordion) => {
    accordion.addEventListener('toggle', function () {
      if (!this.open) return;

      accordions.forEach((item) => {
        if (item !== this) {
          item.removeAttribute('open');
        }
      });
    });
  });
});

//  Video auto control off

  function enableVideoLoop() {
    document.querySelectorAll("video").forEach(video => {
      video.controls = false;
      video.removeAttribute("controls");

      video.loop = true;
      video.autoplay = true;
      video.muted = true;
      video.playsInline = true;
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");

      video.addEventListener("ended", function () {
        this.currentTime = 0;
        this.play();
      });
    });
  }

  enableVideoLoop();

  new MutationObserver(enableVideoLoop).observe(document.body, {
    childList: true,
    subtree: true
  });


  // Popup waitlist JS



   

    const popup = document.getElementById("waitlist-popup");
    // const popupTitle = document.getElementById("popup-product-title");
    const popupEmail = document.getElementById("waitlist-email");
    const popupProduct = document.getElementById("waitlist-product");
    const closeBtn = document.querySelector(".popup-close");
    const popupTags = document.getElementById("waitlist-tags");

    // -------------------------
    // Check if form submitted
    // -------------------------
    const params = new URLSearchParams(window.location.search);

    if (params.get("customer_posted") === "true") {
        popup.style.display = "flex";
    }

    // -------------------------
    // Open popup
    // -------------------------
    document.addEventListener("click", function (e) {

        const btn = e.target.closest(".waitlist-btn");

        if (!btn) return;

        e.preventDefault();

        const productTitle = btn.dataset.productTitle || "Join the Waitlist";
        const productId = btn.dataset.productId || "";
        const productHandle = btn.dataset.productHandle || "";

        // popupTitle.textContent = productTitle;
        popup.dataset.productId = productId;

        if (popupEmail) {
            popupEmail.value = "";
        }

        if (popupProduct) {
            popupProduct.value = productTitle;
        }

        if (popupTags) 
        {
          popupTags.value = `Waitlist, product_handle_${productHandle}`;
        }

        popup.dataset.productId = productId;

        popup.style.display = "flex";

    });

    // -------------------------
    // Close popup
    // -------------------------
    function closePopup() {

        popup.style.display = "none";

        // If customer_posted=true exists, remove it
        const params = new URLSearchParams(window.location.search);

        if (params.get("customer_posted") === "true") {

            window.location.href = window.location.pathname;

        }

    }

    // Close button
    if (closeBtn) {
        closeBtn.addEventListener("click", closePopup);
    }

    // Close outside popup
    if (popup) {
        popup.addEventListener("click", function (e) {

            if (e.target === popup) {
                closePopup();
            }

        });
    }




});

// Duo product shade selection and hover badge
document.querySelectorAll('.shade-selector').forEach(selector => {
  const groups = [
    {
      inputName: 'properties[Shade 1]',
      display: selector.querySelector('[data-shade-group="1"]')
    },
    {
      inputName: 'properties[Shade 2]',
      display: selector.querySelector('[data-shade-group="2"]')
    },
    {
      inputName: 'properties[Shade 3]',
      display: selector.querySelector('[data-shade-group="3"]')
    }
  ];

  // Update the shade name beside the heading
  groups.forEach(group => {
    const radios = selector.querySelectorAll(
      `input[name="${group.inputName}"]`
    );

    const updateName = () => {
      const selected = selector.querySelector(
        `input[name="${group.inputName}"]:checked`
      );

      if (selected && group.display) {
        group.display.textContent = selected.value;
      }
    };

    radios.forEach(radio => {
      radio.addEventListener('change', updateName);
    });

    updateName();
  });

  // Show the shade badge below the hovered swatch
  selector.querySelectorAll('.shade-option').forEach(option => {
    const input = option.querySelector('input[type="radio"]');
    if (!input) return;

    option.addEventListener('mouseenter', () => {
      selector.querySelectorAll('.shade-name-tooltip')
        .forEach(tooltip => tooltip.remove());

      const badge = document.createElement('span');
      badge.className = 'shade-name-tooltip';
      badge.textContent = input.value;

      option.appendChild(badge);
    });

    option.addEventListener('mouseleave', () => {
      option.querySelector('.shade-name-tooltip')?.remove();
    });
  });
});
  

